import axios from "axios";

const loadForms = (callback) => {
    const config = {
        url: '/api/forms',
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const getForm = (id, callback) => {
    const config = {
        url: `/api/forms/${id}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteForm = (id, callback) => {
    const config = {
        url: `/api/forms/${id}`,
        method: 'DELETE',
    }

    axios.request(config).then(response => callback(response.data));
}

const createForm = (formData, callback) => {
    const config = {
        url: '/api/forms',
        method: 'POST',
        data: formData,
    }

    axios.request(config)
        .then(response => callback(response.data));
}

const updateForm = (id, formData, callback) => {
    const config = {
        url: `/api/forms/${id}`,
        method: 'PUT',
        data: formData,
    }

    axios.request(config)
        .then(response => callback(response.data));

}

const FormActions = {
    loadForms,
    getForm,
    deleteForm,
    createForm,
    updateForm,
}

export default FormActions;